import { connect } from 'react-redux'

import { getHistoryQueryParams } from 'selectors/router'
import { getSelectedSnapshot } from 'selectors/feature/snapshots'

import FeatureHistoryTopNav from './FeatureHistoryTopNav'

const mapStateToProps = (state) => {
  const snapshotUri = getHistoryQueryParams(state)
  const selectedSnapshot = getSelectedSnapshot(state, { uri: snapshotUri })

  return {
    snapshotUri,
    selectedSnapshot,
  }
}

export default connect(mapStateToProps)(FeatureHistoryTopNav)
